// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2lFVY","dots":"index_dots_W6wdi","itemPicContainer":"index_itemPicContainer_1HUbh","itemPic":"index_itemPic_1UwWG","itemIcon":"index_itemIcon_14HZm"};